import { Modal } from '../modal/Modal';

import styled from 'styled-components';
import { Button } from '../Button';

export interface ModalDeleteProductProps {
  show?: boolean;
  onClose: () => void;
  onClick: () => void;
  deletedProduct: { survey: any; version: any };
}

export const ModalDeleteProduct = ({ show, onClose, onClick, deletedProduct }: ModalDeleteProductProps) => {
  return (
    <>
      <Modal
        alignment={'center'}
        size={{ width: '50%' }}
        show={show}
        title={`Êtes-vous sûr·e de vouloir supprimer <b>${deletedProduct?.version?.versionName}</b> ?`}
        onClose={onClose}>
        <BasicModalContainer>
          <p>
            Cette action est irréversible. Si vous supprimez le questionnaire, vous perdrez toutes les données liées à la mise en conformité de
            celui-ci. Voulez-vous continuer ?{' '}
          </p>
          <ButtonContainer>
            <Button type={'danger'} onClick={onClick} label={'Supprimer'} />
            <Button type={'light'} onClick={onClose} label={'Annuler'} />
          </ButtonContainer>
        </BasicModalContainer>
      </Modal>
    </>
  );
};

const BasicModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 20px;
  align-items: center;
  row-gap: 26px;

  p {
    font-size: 1.3em;
    font-weight: 400;
    font-family: 'Roboto', serif;
    line-height: 1.5em;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  column-gap: 20px;
  align-items: center;
`;
